import type { Module } from '@/domain/Users/Users';

export interface SecurityUser {
	firstname?: string;
	lastname?: string;
	role?: string;
	organizationId?: string | number;
	organizationName?: string;
	timeZone?: number | string;
	modules?: Module[];
}

export function readSecurityUser(): SecurityUser | null {
	const raw = localStorage.getItem('security');
	return raw ? JSON.parse(raw) : null;
}
